var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgressBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 10,
    viewBox: "0 0 322 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.3149,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 36.3149 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1699,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 48.1699 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0249,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 60.0249 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8799,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 71.8799 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7349,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 83.7349 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5898,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 95.5898 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107.445,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 107.445 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 119.3,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 119.3 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 131.155,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 131.155 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 143.01,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 143.01 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 154.865,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 154.865 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 166.72,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 166.72 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 178.575,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 178.575 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 190.43,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 190.43 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 202.285,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 202.285 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 214.14,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 214.14 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 225.995,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 225.995 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 237.85,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 237.85 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 249.705,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 249.705 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 261.56,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 261.56 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 273.415,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 273.415 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 285.27,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 285.27 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 297.125,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 297.125 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 308.979,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 308.979 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 320.834,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 320.834 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 24.46,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 24.46 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 12.605,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 12.605 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: -2,
    width: 5,
    height: 18,
    transform: "rotate(-20 0.75 -2)",
    fill: "#0C1521",
    fillOpacity: 0.28
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBar);
export default __webpack_public_path__ + "static/media/progressBar.248abf7a79be64548b2bcc15ff8d057f.svg";
export { ForwardRef as ReactComponent };